import classNames from 'classnames';
import { Spinner } from 'components/Spinner/index';
import { ISpinnerProps } from './types';
import styles from './styles.module.scss';

interface IProps extends ISpinnerProps {
  className?: string,
}

export const SpinnerCenteredWrapper = ({ className, ...props }: IProps) => (
  <div className={classNames(styles.wrapper, !className ? '' : className)}>
    <Spinner {...props} />
  </div>
);
